de:
  photos: Fotos
  documents: Dokumente
fr:
  documents: Documents
  photos: Photos
it:
  documents: Documenti
  photos: Foto
